import { combineReducers } from 'redux';
import vap from './vap';
import similarAds from './similarAds';
import popularAssuredAds from './popularAssuredAds';
import user from './user';
import newcars from './newcars';
import snb from './snb';
import homepage from './homepage';
import bikeLanding from './bikeLanding';
import partnerships from './partnerships';
import spotLightAds from './spotLightAds';
import news from './news';
import form from './form';
import deals from './deals';


const reducer = combineReducers({ vap, similarAds, popularAssuredAds, user, newcars, snb, homepage, partnerships, bikeLanding, spotLightAds, form, deals, news });

export default reducer;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/index.js